import { ActionContext, ActionTree } from 'vuex';
import { StateInterface } from '../index';
import { AppInterface } from 'src/store/app/state';
import { showErrorMessageNotify } from 'src/services/notify';
import { Types } from 'src/api/ws-handler';
import { Users } from 'src/api';

const actions: ActionTree<AppInterface, StateInterface> = {
  showServerError(
    context: ActionContext<AppInterface, StateInterface>,
    error: Types.ErrorMessageData
  ) {
    const isDebug = process.env.DEBUGGING as unknown as boolean;
    showErrorMessageNotify({
      message: error.message,
      caption: error.error || 'Server Message',
      position: 'bottom-left',
      timeout: isDebug ? 0 : 5000,
      group: true,
      progress: !isDebug,
      close: isDebug,
    });
  },

  setServerError(
    context: ActionContext<AppInterface, StateInterface>,
    error: Error
  ) {
    if (error.message.includes('result is undefined')) {
      context.commit('SET_UNDEFINED_SERVER_ERROR', true);
    }
  },

  setUser(
    context: ActionContext<AppInterface, StateInterface>,
    user: Users.Types.User
  ) {
    context.commit('SET_USER', user);
  },

  setHost(context: ActionContext<AppInterface, StateInterface>, host: string) {
    context.commit('SET_HOST', host);
  },

  setLeftDrawerOpen(
    context: ActionContext<AppInterface, StateInterface>,
    open: boolean
  ) {
    context.commit('SET_LEFT_DRAWER_OPEN', open);
  },

  toggleLeftDrawerOpen(context: ActionContext<AppInterface, StateInterface>) {
    return context.commit(
      'SET_LEFT_DRAWER_OPEN',
      !context.state.isLeftDrawerOpen
    );
  },

  setPageTitle(
    context: ActionContext<AppInterface, StateInterface>,
    title: string
  ) {
    return context.commit('SET_PAGE_TITLE', title);
  },

  cleanupStorage(context: ActionContext<AppInterface, StateInterface>) {
    void context.dispatch('SET_USER', null);
    void context.dispatch('distribution/SET_BOARDS', [], { root: true });
    void context.dispatch('distribution/SET_EXECUTION_RECORDS', [], {
      root: true,
    });
    void context.dispatch('statistics/resetData', null, { root: true });
  },
};

export default actions;
